import axios from "axios";
import * as config from "../configs/Config";

const TOKEN_KEY = 'dna_token'
const USER_KEY = 'dna_user'

/**
 * Wraps the Laravel user payload in the Cognito-flavoured shape the rest of
 * the UI was written against (currentUser.attributes.email, .sub, etc.).
 */
export const adaptUser = (laravelUser) => {
    if (!laravelUser) return null
    return {
        id: laravelUser.id,
        uuid: laravelUser.uuid,
        is_admin: laravelUser.is_admin,
        referenceId: laravelUser.uuid,
        attributes: {
            email: laravelUser.email,
            sub: laravelUser.uuid,
            uploadsAvailable: 99,
        },
    }
}

export const persistAuth = (token, user) => {
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export const loadAuth = () => {
    const token = localStorage.getItem(TOKEN_KEY)
    if (!token) return null
    try {
        return {token, user: JSON.parse(localStorage.getItem(USER_KEY))}
    } catch (e) {
        return {token, user: null}
    }
}

export const clearAuth = () => {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
}

export const logout = async (token) => {
    try {
        await axios.post(`${config.API_URL}/logout`, {}, {
            headers: {Authorization: `Bearer ${token}`, Accept: 'application/json'}
        })
    } catch (e) {
        // best-effort; clear local state regardless
    } finally {
        clearAuth()
    }
}
